// src/components/admin/contacts/AdminContactsEditor.jsx
import React, { useState, useEffect } from 'react';
import fetchData from '../../../api/fetchData'; // Проверь путь!
import { useTranslation } from 'react-i18next';

function AdminContactsEditor({ onContentUpdated }) {
  const { t } = useTranslation();

  // Состояния для каждого поля
  const [phoneNumber, setPhoneNumber] = useState('');
  const [emailAddress, setEmailAddress] = useState('');
  const [linkedinUrl, setLinkedinUrl] = useState('');
  const [githubUrl, setGithubUrl] = useState('');
  const [telegramUrl, setTelegramUrl] = useState('');

  // Технические состояния
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [saveStatus, setSaveStatus] = useState({ message: '', type: '' });

  useEffect(() => {
    const loadContacts = async () => {
      setLoading(true);
      try {
        const response = await fetchData('/admin/contacts/admin_get_site_contacts.php', 'GET', null, { credentials: 'include' });
        if (response && response.status === 'success' && response.contacts) {
          const { phone_number, email_address, linkedin_url, github_url, telegram_url } = response.contacts;
          setPhoneNumber(phone_number || '');
          setEmailAddress(email_address || '');
          setLinkedinUrl(linkedin_url || '');
          setGithubUrl(github_url || '');
          setTelegramUrl(telegram_url || '');
        } else {
          setError(response?.message || 'Не удалось загрузить контакты.');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    loadContacts();
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    setSaveStatus({ message: '', type: '' });

    const payload = {
      phone_number: phoneNumber,
      email_address: emailAddress,
      linkedin_url: linkedinUrl,
      github_url: githubUrl,
      telegram_url: telegramUrl
    };
    
    try {
      const response = await fetchData('/admin/contacts/admin_save_site_contacts.php', 'POST', payload, { credentials: 'include' });
      if (response && response.status === 'success') {
        setSaveStatus({ message: response.message, type: 'success' });
        if (onContentUpdated) onContentUpdated();
      } else {
        setSaveStatus({ message: response?.message || 'Ошибка сохранения.', type: 'error' });
      }
    } catch (err) {
      setSaveStatus({ message: err.message, type: 'error' });
    } finally {
      setIsSaving(false);
      setTimeout(() => setSaveStatus({ message: '', type: '' }), 5000);
    }
  };

  if (loading) return <p>{t('messages.loading')}</p>;
  if (error) return <p>{t('messages.error.generic', { details: error })}</p>;

  return (
    <div className="admin-contacts-editor">
      <h4>{t('admin.contacts.managerTitle', 'Управление Контактами')}</h4>
      <form onSubmit={handleSave}>
        <fieldset>
          <legend>{t('admin.contacts.legend', 'Контактные данные сайта')}</legend>
          <div>
            <label htmlFor="phone_number">{t('admin.contacts.phoneLabel', 'Телефон')}:</label>
            <input type="text" id="phone_number" value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)} />
          </div>
          <div>
            <label htmlFor="email_address">{t('admin.contacts.emailLabel', 'Email')}:</label>
            <input type="email" id="email_address" value={emailAddress} onChange={e => setEmailAddress(e.target.value)} required />
          </div>
          <div>
            <label htmlFor="linkedin_url">{t('admin.contacts.linkedinLabel', 'URL LinkedIn')}:</label>
            <input type="text" id="linkedin_url" value={linkedinUrl} onChange={e => setLinkedinUrl(e.target.value)} />
          </div>
          <div>
            <label htmlFor="github_url">{t('admin.contacts.githubLabel', 'URL GitHub')}:</label>
            <input type="text" id="github_url" value={githubUrl} onChange={e => setGithubUrl(e.target.value)} />
          </div>
          <div>
            <label htmlFor="telegram_url">{t('admin.contacts.telegramLabel', 'URL Telegram')}:</label>
            <input type="text" id="telegram_url" value={telegramUrl} onChange={e => setTelegramUrl(e.target.value)} />
          </div>
        </fieldset>
        <button type="submit" disabled={isSaving} style={{ marginTop: '10px' }}>
          {isSaving ? t('admin.buttons.saving') : t('admin.buttons.saveSimple', 'Сохранить Контакты')}
        </button>
      </form>
      {saveStatus.message && <p className={`form-status-message ${saveStatus.type}`}>{saveStatus.message}</p>}
    </div>
  );
}

export default AdminContactsEditor;